import React from "react"

import Layout from "../../../components/shared/layout"
import useHeroSmokeImages from "../../../components/shared/hooks/useHeroSmokeImages"

import Hero from "../../../components/shared/hero"
import { HeroOverlay } from "../../../components/sdk/hero.style"
import Overview from "../../../components/sdk/overview"
import FeatureGrid from "../../../components/sdk/features-grid"
import Carousel from "../../../components/sdk/carousel"
import SdkBenefits from "../../../components/sdk/sdk-benefits"
import ContactForm from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"
import SEO from "../../../components/shared/seo"

export default function SdkPage({ location }) {
  const images = useHeroSmokeImages()
  return (
    <Layout location={location}>
      <SEO
        title="Mappedin SDKs"
        description="Mapping SDK - Looking to build a custom mapping solution on your website or app? We have the tools required to create a unique experience while leveraging our knowledge and expertise on search and navigation."
      />
      <Hero
        overlayStyle={HeroOverlay}
        title={"Mobile & Web Mapping SDKs"}
        sizes={images}
        description={
          "Mappedin’s Mobile and Web SDKs have been built to enable all indoor mapping experiences. Regardless of industry, our SDKs encompass a wide variety of components and features required to integrate mapping into a website, mobile application, or custom directory. Used to create our own pre-built applications, Mappedin’s SDKs are the foundation of every indoor mapping experience we’ve built."
        }
      />
      <Overview />
      <FeatureGrid />
      <Carousel />
      <SdkBenefits />
      <ContactForm />
      <Footer />
    </Layout>
  )
}
